<template>
  <div>
    <slot :show="show" />
    <a-modal
      v-model:open="visible"
      width="765px"
      :title="$t('shang-yong-shou-quan-de-qu-bie')"
      :footer="null"
      @ok="hide"
      @cancel="hide"
    >
      <authorization-differences-content :onSubscribeCb="onSubscribeCb" />
    </a-modal>
  </div>
</template>
<script lang="ts" setup>
import AuthorizationDifferencesContent from './authorization-differences-content.vue'
const { $t } = useNuxtApp()

const props = defineProps<{
  onCloseParent?(): void
}>()

const visible = ref(false)

const show = () => {
  visible.value = true
}
const hide = () => {
  visible.value = false
}
const onSubscribeCb = () => {
  hide()
  if (props?.onCloseParent) {
    props.onCloseParent()
  }
}
</script>
